import {NotificationStateType} from "@/store/interfaces/INotifications";
import Api from "@/common/notifications";
import ResponseType from '@/types/IResponse'

export default {
    state: (): NotificationStateType => ({
        notificationsExists: false,
    }),
    mutations: {
        updateNotifications(state: NotificationStateType, status: boolean) {
            state.notificationsExists = status
        }
    },
    actions: {
        checkUnreadNotifications(ctx: any) {
            Api.checkUnreadNotifiactions((res: ResponseType) => {
                ctx.commit('updateNotifications', res.data)
            })
        }
    },
    getters: {
        getNotificationStatus(state: NotificationStateType) {
            return state.notificationsExists
        }
    }
}